/**
 * @file    js/global.js
 *
 * copyright (c) 2006-2014 Frank Hellenkamp [jonas@depage.net]
 *
 * @author    Frank Hellenkamp [jonas@depage.net]
 */

import $ from 'jquery';
import ScrollMagic from 'scrollmagic';
//import 'slick-carousel';
//import './depage-jquery-plugins/depage-analytics';
//import { compile, morph } from 'svg-path-morph';

var gtswp = (function() {
    "use strict";
    /*jslint browser: true*/
    /*global $:false */

    var baseUrl = "";
    var lang = $('html').attr('lang');
    var $main, $footer;
    var assetPath;
    var smc = new ScrollMagic.Controller();

    // local Project instance that holds all variables and public functions
    var localJS = {
        // {{{ ready
        ready: function() {
            $("html").addClass("javascript");

            baseUrl = $("head script[src*='/global.js'], head script[src*='/global.min.js'], head script[src*='/global.dev.min.js']")[0].src;
            baseUrl = baseUrl.replace(/\/js\/global(\.dev)(\.min)?\.js.*/, "");
            assetPath = baseUrl + "/js";

            localJS.setup();

            // setup global events
            $(window).on("statechangecomplete", localJS.setup);

            $main = $("main");
            $footer = $("footer");
        },
        // }}}
        // {{{ setup
        setup: function() {
            localJS.setupVarious();
            localJS.setupNavigation();
            //localJS.setupNewsArchive();
            //localJS.setupSearch();
            localJS.setupScenes();
            //localJS.setupSlideshow();
            //localJS.setupShare();
        },
        // }}}
        // {{{ setupVarious
        setupVarious: function() {
            /*
            var privacyMessage = "We use cookies and similar technologies to understand how you use our services and improve your experience. By clicking 'Accept', you accept all cookies. Otherwise we use only functionally essential cookies. For more information, please see our <a href=\"{$privacyPolicyLink}\">Data Protection Policy</a>";
            if (lang == "de") {
                privacyMessage = "Um unseren Webauftritt für Sie optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies. Wenn Sie 'Akzeptieren' klicken, stimmen Sie der Verwendung aller Cookies zu. Andernfalls verwenden wir nur funktional unverzichtbare Cookies. Weitere Informationen, erhalten Sie in unserer <a href=\"{$privacyPolicyLink}\">Datenschutzerklärung für Webseitenbenutzer</a>.";
            }
            $("body").depageAnalytics({
                messageHtml: privacyMessage,
            });

            // add click event for teaser
            $(".teaser").click( function(e) {
                if (e.isTrigger != 3)  {
                    $("a", this).first().click();
                }
            });
            */

            try {
                $("h1, h2, h3, h1 a, h2 a, h3 a, size-M p, .size-L p, .teaser a, .downloads a, nav.toc span").hyphenate(lang);
            } catch(e) {
            }

            // enhance tel-links
            $("a[href^='tel:']").each(function() {
                var target = "call-" + this.href.replace(/[^a-z0-9]*/gi, "");
                var link = this;

                // load in iframe to supress potential errors when protocol is not available
                var $iframe = $("<iframe name=\"" + target + "\" style=\"display: none\" aria-hidden\"true\"></iframe>").appendTo("body");
                link.target = target;
            });
        },
        // }}}
        // {{{ setupNavigation
        setupNavigation: function() {
            var $navSidebar = $("div.sidebar");
            var $menus = $("div.sidebar > ul > li");

            $navSidebar.on("click", function() {
                $(this).toggleClass("active");
            });
            $menus.each(function() {
                var $current = $(this);
                var $sub = $current.children("ul");

                if ($sub.length > 0) {
                    var $opener = $("<span class=\"opener\"></span>").appendTo(this);

                    $opener.on("click", function(e) {
                        $menus.filter(".parent-of-active").removeClass("parent-of-active");

                        $current.addClass("parent-of-active");

                        e.stopPropagation();
                    });
                }
            });
        },
        // }}}
        // {{{ setupNewsArchive
        setupNewsArchive: function() {
            var $navArchive = $("nav.archive");

            $navArchive.each(function() {
                var filter = window.location.search;
                var parts = filter.match(/\?filter=(\d+(,\d+)?)/);

                var $links = $(this).find("a[href$='" + filter + "']").addClass("active");
            });
        },
        // }}}
        // {{{ setupSearch
        setupSearch: function() {
            var $search = $("nav.search");
            var $searchInput = $search.find("input");

            $search.on("click", function() {
                if ($search.hasClass("active")) {
                    if ($searchInput.val() != '') {
                        $searchInput.parents("form")[0].submit();
                    }
                    $search.removeClass("active");
                } else {
                    $search.addClass("active");
                    $searchInput.focus();
                }
            });
        },
        // }}}
        // {{{ setupScenes
        setupScenes: function() {
            var smcScenes = [];
            var $newslists= $(".newslist");

            var s = new ScrollMagic.Scene({
                    offset: 100,
                })
                .addTo(smc)
                .setClassToggle("body", "scrolled");

            smcScenes.push(s);

            $(".sm-anim").each(function() {
                var el = this;
                var $el = $(this);
                var st = el.style;
                var hook = 0.7;
                var pinned = $el.hasClass("pinned");
                if ($el.is(":last-child")) {
                    hook = 0.85;
                }
                if (pinned) {
                    hook = 0;
                }

                var s = new ScrollMagic.Scene({
                        triggerElement: el,
                        triggerHook: hook
                    })
                    .addTo(smc)
                    .setClassToggle(el, "in-view");

                smcScenes.push(s);
            });
        },
        // }}}
        // {{{ setupSlideshow
        setupSlideshow: function() {
            var $slideshows = $(".type-slideshow:not(.slick-initialized)").each( function() {
                var $slideshow = $(this);

                //$slideshow.depageSlideshow();

                //return;
                $slideshow.slick({
                    //slide: "div:not(.flex-spacer)",
                    dots: true,
                    arrows: true,
                    autoplay: true,
                    autoplaySpeed: 7000,
                    //pauseOnHover: true,
                    pauseOnDotsHover: true,
                    pauseOnFocus: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    variableWidth: true,
                    //fade: true,
                });
            });

            var $flowy = $(".style-flowy > .inner:not(.slick-initialized)").each( function() {
                var $flowy = $(this);

                $flowy.slick({
                    dots: true,
                    arrows: true,
                    autoplay: true,
                    autoplaySpeed: 5000,
                    pauseOnDotsHover: true,
                    //pauseOnFocus: true,
                    slidesToShow: 1,
                    centerMode: true,
                    centerMode: true,
                    slidesToScroll: 1,
                    infinite: true,
                    variableWidth: true,
                    /*
                    responsive: [{
                        breakpoint: 1640,
                        settings: {
                            slidesToShow: 1,
                            centerMode: true,
                        }
                    }],
                    */
                });
            });

            var $wall = $(".type-wall01").each( function() {
                var $wall = $(this);
                var $slides = $wall.children(".slide");
                var currentActive = -1;
                var nextSlideTimer = null;
                var setActiveSlide = function(active) {
                    var $slide = $slides.eq(active);
                    var className = "active-" + (active + 1);
                    var removeClass = ["active", "active-" + (currentActive + 1)];

                    $wall.removeClass(removeClass);
                    $slides.eq(currentActive).removeClass("active");

                    if (currentActive != active) {
                        $wall.addClass(className).addClass("active");
                        $slide.addClass("active");

                        currentActive = active;
                    } else {
                        currentActive = -1;
                    }
                };
                var nextSlide = function() {
                    var active = currentActive + 1;

                    if (active >= $slides.length) {
                        active = 0;
                    }
                    setActiveSlide(active);
                    clearTimeout(nextSlideTimer);
                    nextSlideTimer = setTimeout(nextSlide, 5000);
                };
                var prevSlide = function() {
                    var active = currentActive - 1;

                    if (active < 0) {
                        active = $slides.length - 1;
                    }
                    setActiveSlide(active);
                    clearTimeout(nextSlideTimer);
                    nextSlideTimer = setTimeout(prevSlide, 5000);
                };

                var $nextButton = $("<button class='slick-next slick-arrow' type='button' aria-label='Next' role='button'>Next</button>")
                    .on("click", nextSlide)
                    .appendTo($wall);

                var $prevButton = $("<button class='slick-prev slick-arrow' type='button' aria-label='Previous' role='button'>Previous</button>")
                    .on("click", prevSlide)
                    .appendTo($wall);

                $slides.each( function(i) {
                    var $slide = $(this);

                    $slide.on("click", function() {
                        clearTimeout(nextSlideTimer);
                        setActiveSlide(i);
                    });
                });

                nextSlideTimer = setTimeout(nextSlide, 5000);
            });

            var $newswall = $(".newslist.style-wall .inner").each( function() {
                var $wall = $(this);
                var $slides = $wall.children(".teaser");
                var num = 7;
                var current = 0;

                var updateActive = function() {
                    $slides.each( function(i) {
                        $(this).toggleClass("active", i >= current && i < current + num || i <= current - $slides.length + num - 1);
                    });

                    current++;
                    if (current % $slides.length == 0) {
                        current = 0;
                    }
                };

                updateActive();
                setInterval(updateActive, 5000);
            });
        },
        // }}}
        // {{{ setupShare
        setupShare: function() {
            if (!navigator.canShare) {
                return;
            }

            var $share = $("<a class=\"share\" title=\"Share\">Share</a>");

            let shareData = {
                title: document.title,
                text: document.title,
                url: location.href
            }

            $share.on('click', function() {
                navigator.share(shareData).then(() => {
                    console.log("shared");
                })
                .catch((e) => {
                    console.log('error: ' + e)
                });
            });

            $share.clone(true).insertAfter("footer.bottom .twitter");
            $share.clone(true).appendTo(".share-container");
        }
        // }}}
    };

    return localJS;
})();

// {{{ register ready event
$(function() {
    gtswp.ready();
});
// }}}

// vim:set ft=javascript sw=4 sts=4 fdm=marker :
